import { Box, SxProps } from "@mui/material";
import { ReactNode } from "react";

interface ArchivedOverlayProps {
  children: ReactNode;
  isArchived?: boolean;
  sx?: SxProps;
}

const ArchivedOverlay = ({
  children,
  sx,
  isArchived = false,
}: ArchivedOverlayProps) => {
  return (
    <Box
      sx={{
        opacity: isArchived ? 0.5 : 1,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ArchivedOverlay;
